// LiveView rejects hook pushes during disconnects. These are expected during
// navigation/network loss; unrelated failures must still reach error reporting.
// Callers explicitly retry idempotent state sync from reconnected(). User actions
// are never queued here, since replaying a stale action can modify a new page.
export async function pushHookEvent(hook, event, payload = {}) {
  try {
    await hook.pushEvent(event, payload)
    return true
  } catch (error) {
    if (error?.message === "unable to push hook event. LiveView not connected" ||
        error?.message === "no connection") return false
    throw error
  }
}
